/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import React from 'react';
import {Helmet} from 'react-helmet';
// import styled from 'styled-components';
import {Switch, Route} from 'react-router-dom';

import GamePage from '../GamePage/index';

import Container from '@material-ui/core/Container';
import VsAI from '../GamePage/VsAI';
import OnlineVs from "../GamePage/OnlineVs";
import MenuPage from "./menu/MenuPage";
// import GlobalStyle from '../../global-styles';

// const AppWrapper = styled.div`
//   max-width: calc(768px + 16px * 2);
//   margin: 0 auto;
//   display: flex;
//   min-height: 100%;
//   padding: 0 16px;
//   flex-direction: column;
// `;

export default function App() {
  return (
    <Container maxWidth="lg">
      {/* // <AppWrapper>  */}
      <Helmet
        titleTemplate="%s - 237th Card Game"
        defaultTitle="237th Card Game"
      >
        <meta name="description" content="A React.js Boilerplate application"/>
      </Helmet>
      {/* <Header /> */}
      <Switch>
        <Route exact path="/" component={() => <div>
          <MenuPage/></div>}/>
        <Route path="/game" component={GamePage}/>
        <Route path="/ai" component={VsAI}/>
        <Route path="/online" component={OnlineVs}/>
        <Route path="" component={() => <div>404</div>}/>
      </Switch>
      {/* <Footer /> */}
      {/*<GlobalStyle />*/}
    </Container>
  );
}
